import { Card } from "@/src/components/wrappers/Card";
import { Booking } from "../../model";
import { Button } from "@/src/components/ui/button";

const TransferSection = ({ booking }: { booking: Booking }) => {
  return (
    <Card className="w-full flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Transfer</h3>
        <Button
          onClick={() => {
            alert("Feature in development");
          }}
          variant="link"
        >
          Edit
        </Button>{" "}
      </div>
      <span className="text--slate-700 text-base italic">Feature in development</span>
    </Card>
  );
};

export default TransferSection;
